import { faTimes as lightTimes } from "@jewlr/pro-light-svg-icons/faTimes"
import PropTypes from "prop-types"

import withFilters from "areas/collection/hoc/with-filters"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

const InternalFilterTags = ({ clearAllTags, tags, removeFilter }) => {
  if (tags && tags.length < 1) return null

  return (
    <section
      aria-label="Selected filters"
      className="desktop:my-0 my-12 flex flex-auto"
    >
      <ul className="flex list-none flex-wrap justify-start gap-10">
        {tags.map((tag) => (
          <li
            className="bg-sku-kw text-14 leading-25 relative flex items-center rounded px-10 py-2 font-bold text-black"
            data-cy={`collection-filter-tag-${tag.name}`}
            key={`tag${tag.name}`}
          >
            {tag.name}
            <Button
              aria-label={`Remove filter ${tag.name}`}
              className="rounded-16 text-10 ml-10 h-16 w-16 bg-transparent p-0 align-bottom text-black"
              onClick={(e) => removeFilter(e, tag.filter_param)}
              variant="tertiary"
            >
              <FontAwesomeIcon icon={lightTimes} />
            </Button>
          </li>
        ))}
        <Button
          aria-label="Clear all filters"
          className="text-14 leading-25 px-10 py-2 font-bold"
          data-cy="collection-filter-tag-clear-all"
          onClick={(e) => clearAllTags(e)}
          text
          underline
        >
          Clear Selection
        </Button>
      </ul>
    </section>
  )
}

InternalFilterTags.propTypes = {
  clearAllTags: PropTypes.func,
  removeFilter: PropTypes.func,
  tags: PropTypes.array,
}

const FilterTags = withFilters(InternalFilterTags)

export default FilterTags
